import { useState, useEffect } from 'react'
import { syncApi } from '../services/api'
import Button from '../components/common/Button'
import { useNavigate } from 'react-router-dom'

export default function SyncLogs() {
    const [logs, setLogs] = useState([])
    const [loading, setLoading] = useState(true)
    const [expandedLog, setExpandedLog] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        loadLogs()
    }, [])

    async function loadLogs() {
        try {
            const response = await syncApi.getLogs()
            if (response.success) {
                const errorsOnly = (response.logs || []).filter(
                    log => log.status === 'error' || log.status === 'failed'
                )
                setLogs(errorsOnly)
            }
        } catch (error) {
            console.error('Failed to load logs:', error)
        }
        setLoading(false)
    }

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="spinner w-8 h-8"></div>
            </div>
        )
    }

    return (
        <div>
            <div className="page-header flex items-center justify-between">
                <div>
                    <h1 className="page-title">Error Logs</h1>
                    <p className="text-blue-100 mt-1">Last 100 errors — most recent first</p>
                </div>
                <div className="flex gap-2">
                    <Button variant="secondary" onClick={loadLogs}>
                        🔄 Refresh
                    </Button>
                    <Button variant="secondary" onClick={() => navigate('/admin/sync')}>
                        ← Back to Sync Dashboard
                    </Button>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-md overflow-hidden">
                {logs.length === 0 ? (
                    <div className="text-center py-16 text-gray-500">
                        <p className="text-4xl mb-4">✅</p>
                        <p className="text-lg font-medium">No errors logged</p>
                        <p className="text-sm mt-1">Everything is running smoothly</p>
                    </div>
                ) : (
                    <table className="w-full">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Time</th>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Action</th>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Status</th>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Message</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y">
                            {logs.map((log, index) => (
                                <tr key={index} className="bg-red-50">
                                    <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">
                                        {new Date(log.createdAt).toLocaleString()}
                                    </td>
                                    <td className="px-4 py-3 text-sm font-medium">
                                        {log.commandType?.replace(/_/g, ' ')}
                                    </td>
                                    <td className="px-4 py-3">
                                        <span className="text-xs px-2 py-1 rounded font-medium bg-red-100 text-red-800">
                                            {log.status}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3 text-sm">
                                        {log.message && log.message.length > 80 ? (
                                            <div>
                                                <span className="text-red-700">
                                                    {expandedLog === index
                                                        ? log.message
                                                        : `${log.message.substring(0, 80)}...`}
                                                </span>
                                                <button
                                                    onClick={() => setExpandedLog(expandedLog === index ? null : index)}
                                                    className="ml-2 text-blue-600 hover:underline text-xs"
                                                >
                                                    {expandedLog === index ? 'Show less' : 'Show more'}
                                                </button>
                                            </div>
                                        ) : (
                                            <span className="text-red-700">{log.message || '-'}</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    )
}